import { render } from "./RankListPage.vue?vue&type=template&id=25a742aa"
import script from "./RankListPage.vue?vue&type=script&lang=js"
export * from "./RankListPage.vue?vue&type=script&lang=js"

import "./RankListPage.vue?vue&type=style&index=0&id=25a742aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__